import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEllipsisVertical = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 128 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z" })
});
export default SvgEllipsisVertical;
